/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import DevicesComponent from './devices.Components';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import * as actions from '../../actions/login.Action';
import { isTwoObjectSame } from '../../services/utility';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class Devices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            devicesList: [],
            status: [{ option: "Active", value: "active" }, { option: "InActive", value: "inActive" }],
            selectedStatus: "active",
            searchDeviceText: "",
            searchAttestationText: "",
            searchDeviceName: "",
            searchUserNameText: "",
            isEditAssignEmployeeAndProject: false,

            selectedDeviceDetails: [],
            isEditDevice: false,
            deviceStatusOptions: this.getActiveOptions(),
            assignedProjects: [],
            selectedAsignedProject: [],
            isSetButtonDisabled: false,

            isCopyDevice: false,
            copyDeviceListForEmployee: [],
            copyDeviceListForProject: [],
            isDisableReplaceOrAppendBtn: false,
            selectedCopyDevicesForEmp: new Map(),
            selectedCopyDevicesForPro: new Map(),
            selectAllCopyDevicesForEmp: false,
            selectAllCopyDevicesForPro: false,

            deviceAttestationStatusOptions: this.getActiveOptions(),
            selectedDeviceAttestationOptions: [],
            deviceSignatureOptions: this.getActiveOptions(),
            selectedDeviceSignatureOptions: [],
            searchSignatureText: "",

            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },

            employeeEmails: [],
            searchDeviceEmployeeText: "",
            searchDeviceProjectText: "",
            saveBtnDisabled: false,

            // Employee
            assignedEmpsDevicesIntheMainPage: [],
            unAssignedEmpsForDeviceModal: [],
            assignedEmpsForDeviceModal: [],
            selectAllUnAssignedEmps: false,
            selectAllAssignedEmps: false,
            selectedUnAssignedEmpsMap: new Map(), // currently selected unassigned emps still not moved
            selectedAssignedEmpsMap: new Map(), // currently selected assigned emps still not moved

            // Project
            assignedProsDevicesIntheMainPage: [],
            unAssignedProsForDeviceModal: [],
            assignedProsForDeviceModal: [],
            selectAllUnAssignedPros: false,
            selectAllAssignedPros: false,
            selectedUnAssignedProsMap: new Map(), // currently selected unassigned pros still not moved
            selectedAssignedProsMap: new Map(), // currently selected assigned pros still not moved
        };

        // global
        this.allDevices = null;
        this.currentlySelectedDevice = null;
        this.allEmployees = null;
        this.allProjects = null;
        this.allCopyDevices = null;

        // should be reset
        this.currentCopyEmpDeviceCurrentTake = Constants.DEFAULT_TAKE;
        this.currentCopyProDeviceCurrentTake = Constants.DEFAULT_TAKE;
        this.unAssignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
        this.assignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
        this.unAssignedProsCurrentTake = Constants.DEFAULT_TAKE;
        this.assignedProsCurrentTake = Constants.DEFAULT_TAKE;
        this.fetchedUnAssignedEmps = false;
        this.fetchedAssignedEmps = false;
        this.tempAssignedEmpIds = null;
        this.fetchedUnAssignedPros = false;
        this.fetchedAssignedPros = false;
        this.tempAssignedProIds = null;
        this.editingDeviceId = null;
        this.selectedCopyDevice = null;
        this.searchUnAssignDeviceEmpText = "";
        this.searchAssignDeviceEmpText = "";
        this.searchUnAssignDeviceProText = "";
        this.searchAssignDeviceProText = "";
        this.searchCopyDeviceEmpText = "";
        this.searchCopyDeviceProText = "";

        this.originalAssignedEmps = new Map(); // this tracks all the original assigned emps
        this.orginalAssignedPros = new Map(); // this tracks all the original assigned pros

        this.empUnAssignTrackMap = new Map(); // this tracks all the current emps in the unassigned if moved to assigned it will deleted
        this.empAssignTrackMap = new Map(); // this tracks all the current emps in the assigned if moved to unassigned it will deleted
        this.proUnAssignTrackMap = new Map(); // this tracks all the current pros in the unassigned if moved to assigned it will deleted
        this.proAssignTrackMap = new Map(); // this tracks all the current pros in the assigned if moved to unassigned it will deleted

        this.allUnAssignedEmpsWithoutSlicing = new Map();
        this.allAssignedEmpsWithoutSlicing = new Map();
        this.allUnAssignedProsWithoutSlicing = new Map();
        this.allAssignedProsWithoutSlicing = new Map();
        this.allCopyDevicesForEmpWithoutSlicing = new Map();
        this.allCopyDevicesForProWithoutSlicing = new Map();

        this.assignEmpSearchTimeOut = null;
        this.unAssignEmpSearchTimeOut = null;
        this.assignProSearchTimeOut = null;
        this.unAssignProSearchTimeOut = null;
        this.deviceNameSearchTimeOut = null;
        this.userNameSearchTimeOut = null;
        this.employeeSearchTimeOut = null;
        this.projectSearchTimeOut = null;
        this.copyDeviceForEmpTimeOut = null;
        this.copyDeviceForProTimeOut = null;

        this.currentlySelectedDeviceDetails = null;
        // should be reset

        // for testing
        this.mock = false && (window?.location?.host?.includes("localhost") ?? false);
        this.totalUnAssigned = 5000; // this should be higher than assigned
        this.totalAssigned = 1000;
        // for testing
    };

    componentDidMount() {
        this.getAllDevices({ oneTime: true });
        this.getAllActiveEmployeesEmails();
    }

    componentWillUnmount() {
        clearTimeout(this.assignEmpSearchTimeOut);
        clearTimeout(this.unAssignEmpSearchTimeOut);
        clearTimeout(this.assignProSearchTimeOut);
        clearTimeout(this.unAssignProSearchTimeOut);
        clearTimeout(this.deviceNameSearchTimeOut);
        clearTimeout(this.userNameSearchTimeOut);
        clearTimeout(this.employeeSearchTimeOut);
        clearTimeout(this.projectSearchTimeOut);
        clearTimeout(this.copyDeviceForEmpTimeOut);
        clearTimeout(this.copyDeviceForProTimeOut);
    }

    clone(data) {
        return JSON.parse(JSON.stringify(data ?? []));
    }

    fetchNext(type) {
        switch (type) {
            case Constants.ASSIGN_EMP:
                if (this.assignedEmpsCurrentTake >= this.allEmployees?.length) {
                    return;
                }
                this.assignedEmpsCurrentTake += Constants.DEFAULT_TAKE;
                this.searchAndFilterAssignedEmps();
                break;
            case Constants.UNASSIGN_EMP:
                if (this.unAssignedEmpsCurrentTake >= this.allEmployees?.length) {
                    return;
                }
                this.unAssignedEmpsCurrentTake += Constants.DEFAULT_TAKE;
                this.searchAndFilterUnAssignedEmps();
                break;
            case Constants.ASSIGN_PRO:
                if (this.assignedProsCurrentTake >= this.allProjects?.length) {
                    return;
                }
                this.assignedProsCurrentTake += Constants.DEFAULT_TAKE;
                this.searchAndFilterAssignedPros();
                break;
            case Constants.UNASSIGN_PRO:
                if (this.unAssignedProsCurrentTake >= this.allProjects?.length) {
                    return;
                }
                this.unAssignedProsCurrentTake += Constants.DEFAULT_TAKE;
                this.searchAndFilterUnAssignedPros();
                break;
            case Constants.COPY_DEVICE_EMP_SCROLL:
                if (this.currentCopyEmpDeviceCurrentTake >= this.allCopyDevices) {
                    return;
                }
                this.currentCopyEmpDeviceCurrentTake += Constants.DEFAULT_TAKE;
                this.searchAndFilterCopyDevicesForEmp();
                break;
            case Constants.COPY_DEVICE_PRO_SCROLL:
                if (this.currentCopyProDeviceCurrentTake >= this.allCopyDevices) {
                    return;
                }
                this.currentCopyProDeviceCurrentTake += Constants.DEFAULT_TAKE;
                this.searchAndFilterCopyDevicesForPro();
                break;
            default:
                break;
        }
    }

    getActiveOptions() {
        return [
            { key: 'Active', text: 'Active', value: 'active' },
            { key: 'InActive', text: 'InActive', value: 'inactive' },
        ];
    }

    getAllActiveEmployeesEmails() {
        const selectEmployee = { value: null, key: null, text: 'Select Employee' };
        const url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.GT_A_CT_EMPLE_M}`;

        Api.Get(url, this).then((responseData) => {
            if (responseData && responseData.success) {
                const employeeEmails = [selectEmployee];
                responseData.data.forEach(d => {
                    employeeEmails.push({
                        value: d.empID,
                        key: d.empID,
                        text: `${d.employeeNumber}-${d.emailAddress.toLowerCase()}`,
                    });
                });
                this.setState({ employeeEmails });
            } else {
                this.setState({ employeeEmails: [selectEmployee] });
            }
        });
    }

    getAllDevices({ oneTime = false, dontChangeSelectedDevice = false } = {}) {
        const { searchDeviceText, searchUserNameText, searchAttestationText, searchSignatureText, pagination } = this.state;
        const searchArray = [];

        if (searchDeviceText) {
            searchArray.push({
                FieldName: Constants.DEVICE_NAME,
                Value: searchDeviceText
            });
        }

        if (searchAttestationText) {
            searchArray.push({
                FieldName: Constants.ALLOW_ATTESTATION,
                Value: searchAttestationText
            });
        }

        if (searchSignatureText) {
            searchArray.push({
                FieldName: Constants.ALLOW_TM_VOUCHER_SIGNATURE,
                Value: searchSignatureText
            });
        }

        if (searchUserNameText) {
            searchArray.push({
                FieldName: Constants.USER_NAME,
                Value: searchUserNameText
            });
        };

        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        });

        const requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take,
            Status: this.state.selectedStatus
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_DEVCE_LT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    const devicesList = responseData?.data ?? [];
                    this.allDevices = this.clone(devicesList);
                    const deviceId = devicesList?.length > 0 ? devicesList[0].deviceID : -1;
                    this.setSelectedDevice({ deviceId, dontChangeSelectedDevice });
                    this.setState({ devicesList, pagination }, () => {
                        if (oneTime) {
                            this.getUnassignedEmployeesForDeviceModal();
                            this.getUnassignedProjectsForDeviceModal();
                        }
                    });
                } else {
                    this.setState({ devicesList: [] });
                }
            }
        });
    }

    // EMPLOYEE
    filterAssignedEmpsFromUnAssignedEmps(empIds = []) {
        if (!this.fetchedAssignedEmps) {
            this.fetchedAssignedEmps = true;
            this.tempAssignedEmpIds = this.clone(empIds);
        }
        if (!this.fetchedUnAssignedEmps) return;

        // tempAssignedEmpIds means current assigned emp ids
        const unAssignedEmps = this.allEmployees?.filter(a => !this.tempAssignedEmpIds.includes(a.empID)) ?? [];

        // here we are storing all the unassigned and assigned emps id before slicing
        this.allUnAssignedEmpsWithoutSlicing.clear();
        this.allAssignedEmpsWithoutSlicing.clear();

        unAssignedEmps.forEach(a => {
            this.empUnAssignTrackMap.set(a.empID, true);
            this.allUnAssignedEmpsWithoutSlicing.set(a.empID, true);
        });

        this.tempAssignedEmpIds.forEach(a => {
            this.empAssignTrackMap.set(a, true);
            this.allAssignedEmpsWithoutSlicing.set(a, true);
        });

        this.setState({ unAssignedEmpsForDeviceModal: this.clone(unAssignedEmps?.slice(0, this.unAssignedEmpsCurrentTake)) });
    }

    searchAndFilterUnAssignedEmps() {
        const text = this.searchUnAssignDeviceEmpText?.split(" ");
        const emps = this.allEmployees
            ?.filter(a => this.empUnAssignTrackMap.has(a.empID))
            ?.filter(a => text.every(b => `${a.employeeNumber} - ${a.fullName}${a.division}${a.projectNumber}`?.toLowerCase()?.includes(b)));

        const empIds = emps.map(a => a.empID);
        this.allUnAssignedEmpsWithoutSlicing.clear();
        empIds.forEach(a => this.allUnAssignedEmpsWithoutSlicing.set(a, true));

        const selectAllUnAssignedEmps = empIds.length > 0 && empIds.every(a => this.state.selectedUnAssignedEmpsMap.has(a));
        const clonedEmps = this.clone(emps?.slice(0, this.unAssignedEmpsCurrentTake));
        this.setState({ unAssignedEmpsForDeviceModal: clonedEmps, selectAllUnAssignedEmps });
    }

    searchAndFilterAssignedEmps() {
        const text = this.searchAssignDeviceEmpText?.split(" ");
        const emps = this.allEmployees
            ?.filter(a => this.empAssignTrackMap.has(a.empID))
            ?.filter(a => text.every(b => `${a.employeeNumber} - ${a.fullName}${a.division}${a.projectNumber}`?.toLowerCase()?.includes(b)));

        const empIds = emps.map(a => a.empID);
        this.allAssignedEmpsWithoutSlicing.clear();
        empIds.forEach(a => this.allAssignedEmpsWithoutSlicing.set(a, true));

        const selectAllAssignedEmps = empIds.length > 0 && empIds.every(a => this.state.selectedAssignedEmpsMap.has(a));
        const clonedEmps = this.clone(emps?.slice(0, this.assignedEmpsCurrentTake));
        this.setState({ assignedEmpsForDeviceModal: clonedEmps, selectAllAssignedEmps });
    }

    // PROJECT
    filterAssignedProsFromUnAssignedPros(proIds = []) {
        if (!this.fetchedAssignedPros) {
            this.fetchedAssignedPros = true;
            this.tempAssignedProIds = this.clone(proIds);
        }
        if (!this.fetchedUnAssignedPros) return;

        const unAssignedPros = this.allProjects?.filter(a => !this.tempAssignedProIds.includes(a.projectID)) ?? [];

        this.allUnAssignedProsWithoutSlicing.clear();
        this.allAssignedProsWithoutSlicing.clear();

        unAssignedPros.forEach(a => {
            this.proUnAssignTrackMap.set(a.projectID, true);
            this.allUnAssignedProsWithoutSlicing.set(a.projectID, true);
        });

        this.tempAssignedProIds.forEach(a => {
            this.proAssignTrackMap.set(a, true);
            this.allAssignedProsWithoutSlicing.set(a, true);
        });

        this.setState({ unAssignedProsForDeviceModal: this.clone(unAssignedPros?.slice(0, this.unAssignedProsCurrentTake)) });
    }

    searchAndFilterUnAssignedPros() {
        const { selectedUnAssignedProsMap } = this.state;

        const text = this.searchUnAssignDeviceProText;
        const pros = this.allProjects
            ?.filter(a => this.proUnAssignTrackMap.has(a.projectID))
            ?.filter(a => `${a.projectNumber} - ${a.projectName}`?.toLowerCase()?.includes(text));

        const proIds = pros.map(a => a.projectID);
        this.allUnAssignedProsWithoutSlicing.clear();
        proIds.forEach(a => this.allUnAssignedProsWithoutSlicing.set(a, true));

        const selectAllUnAssignedPros = proIds.length > 0 && proIds.every(a => selectedUnAssignedProsMap.has(a));
        const clonedPros = this.clone(pros?.slice(0, this.unAssignedProsCurrentTake));
        this.setState({ unAssignedProsForDeviceModal: clonedPros, selectAllUnAssignedPros, selectedUnAssignedProsMap });
    }

    searchAndFilterAssignedPros() {
        const { selectedAssignedProsMap } = this.state;

        const text = this.searchAssignDeviceProText;
        const pros = this.allProjects
            ?.filter(a => this.proAssignTrackMap.has(a.projectID))
            ?.filter(a => `${a.projectNumber} - ${a.projectName}`?.toLowerCase().includes(text));

        const proIds = pros.map(a => a.projectID);
        this.allAssignedProsWithoutSlicing.clear();
        proIds.forEach(a => this.allAssignedProsWithoutSlicing.set(a, true));

        const selectAllAssignedPros = proIds.length > 0 && proIds.every(a => selectedAssignedProsMap.has(a));
        const clonedPros = this.clone(pros?.slice(0, this.assignedProsCurrentTake));
        this.setState({ assignedProsForDeviceModal: clonedPros, selectAllAssignedPros });
    }

    // EMPLOYEE
    getAlreadyAssignedEmployeesForDeviceMainPage() {
        const deviceId = this.getSelectedDevice().deviceID;
        if (!deviceId) {
            this.setState({ assignedEmpsDevicesIntheMainPage: [] });
            return;
        }

        const { searchDeviceEmployeeText } = this.state;
        const searchArray = [];

        if (searchDeviceEmployeeText) {
            searchArray.push({
                FieldName: Constants.DEVICE_EMPLOYEE_NAME_AND_NUMBER,
                Value: searchDeviceEmployeeText
            });
        }

        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        });

        const requestData = {
            SearchText: searchArray
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_DEVCE_A_EMPLE_M}?deviceId=${deviceId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    this.setState({ assignedEmpsDevicesIntheMainPage: responseData.data.employees });
                } else {
                    this.setState({ assignedEmpsDevicesIntheMainPage: [] });
                }
            }
        });
    }

    getAssignedEmployeesForDeviceModal() {
        const deviceId = this.getSelectedDevice().deviceID;
        if (!deviceId) return;

        const searchArray = [{
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        }];

        const requestData = {
            SearchText: searchArray,
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_DEVCE_A_EMPLE_M}?deviceId=${deviceId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    let allEmps = null;
                    if (this.mock) {
                        // remove
                        allEmps = this.mockEmpResponse(this.totalAssigned);
                        // remove
                    } else {
                        allEmps = responseData?.data?.employees ?? [];
                    }
                    const empIds = allEmps.map(a => a.empID);
                    this.originalAssignedEmps.clear();
                    empIds.forEach(a => this.originalAssignedEmps.set(a, true));
                    this.filterAssignedEmpsFromUnAssignedEmps(empIds);
                    this.setState({ assignedEmpsForDeviceModal: allEmps?.slice(0, this.assignedEmpsCurrentTake) });
                } else {
                    this.setState({ assignedEmpsForDeviceModal: [] });
                }
            }
        });
    }

     getUnassignedEmployeesForDeviceModal() {
        const deviceId = this.getSelectedDevice().deviceID;
        if (!deviceId) return;

        const searchArray = [{
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        }];

        const requestData = {
            SearchText: searchArray
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_DEVCE_UN_EMPLE_M}?deviceId=${deviceId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    if (this.mock) {
                        // remove
                        this.allEmployees = this.mockEmpResponse(this.totalUnAssigned);
                        // remove
                    } else {
                        this.allEmployees = responseData?.data?.unAssignedEmployees ?? [];
                    }
                    this.fetchedUnAssignedEmps = true;
                    if (this.fetchedAssignedEmps) {
                        this.filterAssignedEmpsFromUnAssignedEmps();
                    }
                } else {
                    this.allEmployees = null;
                }
            }
        });
    }
    
    // PROJECT
    getAlreadyAssignedProjectsForDeviceMainPage() {
        const deviceId = this.getSelectedDevice().deviceID;
        if (!deviceId) {
            this.setState({ assignedProsDevicesIntheMainPage: [] });
            return;
        }

        const { searchDeviceProjectText } = this.state;
        const searchArray = [];

        if (searchDeviceProjectText) {
            searchArray.push({
                FieldName: Constants.DEVICE_PROJECT_NAME,
                Value: searchDeviceProjectText
            });
        };

        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        });

        const requestData = {
            SearchText: searchArray
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_DEVCE_A_PJT_M}?deviceId=${deviceId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    this.setState({ assignedProsDevicesIntheMainPage: responseData.data.projects });
                } else {
                    this.setState({ assignedProsDevicesIntheMainPage: [] });
                }
            }
        });
    }

    sleep(ms) {
        return new Promise((resolve) => setTimeout(() => resolve(true), ms))
    }

    getAssignedProjectsForDeviceModal() {
        const deviceId = this.getSelectedDevice().deviceID;
        if (!deviceId) return;

        const searchArray = [{
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        }];

        const requestData = {
            SearchText: searchArray
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_DEVCE_A_PJT_M}?deviceId=${deviceId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    let allPros = null;
                    if (this.mock) {
                        // remove
                        allPros = this.mockProResponse(this.totalAssigned);
                        // remove
                    } else {
                        allPros = responseData?.data?.projects ?? [];
                    }
                    const proIds = allPros.map(a => a.projectID);
                    this.orginalAssignedPros.clear();
                    proIds.forEach(a => this.orginalAssignedPros.set(a, true));
                    this.filterAssignedProsFromUnAssignedPros(proIds);
                    this.setState({ assignedProsForDeviceModal: allPros?.slice(0, this.assignedProsCurrentTake) });
                } else {
                    this.setState({ assignedProsForDeviceModal: [] });
                }
            }
        });
    }

    getUnassignedProjectsForDeviceModal() {
        const deviceId = this.getSelectedDevice().deviceID;
        if (!deviceId) return;

        const searchArray = [{
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        }];

        const requestData = {
            SearchText: searchArray
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_DEVCE_UN_PJT_M}?deviceId=${deviceId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    if (this.mock) {
                        // remove
                        this.allProjects = this.mockProResponse(this.totalUnAssigned);
                        // remove
                    } else {
                        this.allProjects = responseData?.data?.unAssignedProjects ?? [];
                    }
                    this.fetchedUnAssignedPros = true;
                    if (this.fetchedAssignedPros) {
                        this.filterAssignedProsFromUnAssignedPros();
                    }
                } else {
                    this.allProjects = [];
                }
            }

        });
    }

    handleChange(event) {
        this.setState({
            selectedStatus: event.target.value,
            option: event.target.name,
            pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE },
            searchDeviceText: "",
            searchAttestationText: "",
            searchDeviceEmployeeText: "",
            searchDeviceProjectText: "",
            searchSignatureText: "",
            searchUserNameText: "",
            selectedDeviceAttestationOptions: [],
            selectedDeviceSignatureOptions: [],
            assignedEmpsDevicesIntheMainPage: [],
            assignedProsDevicesIntheMainPage: [],
        }, () => {
            this.getAllDevices();
        });
    }

    onDeviceSearch(event) {
        if (event.target.name === Constants.DEVICE_NAME) {
            this.setState({ searchDeviceText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
                clearTimeout(this.deviceNameSearchTimeOut);
                this.deviceNameSearchTimeOut = setTimeout(() => { this.getAllDevices() }, 1000);
            });
        }

        if (event.target.name === Constants.ALLOW_ATTESTATION) {
            this.setState({ searchAttestationText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
                setTimeout(() => { this.getAllDevices() }, 1000);
            });
        }

        if (event.target.name === Constants.ALLOW_TM_VOUCHER_SIGNATURE) {
            this.setState({ searchSignatureText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
                setTimeout(() => { this.getAllDevices() }, 1000);
            });
        }

        if (event.target.name === Constants.USER_NAME) {
            this.setState({ searchUserNameText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
                clearTimeout(this.userNameSearchTimeOut);
                this.userNameSearchTimeOut = setTimeout(() => { this.getAllDevices() }, 1000);
            });
        }
    }

    onDeviceEmployeeSearch(event) {
        this.setState({ searchDeviceEmployeeText: event.target.value }, () => {
            clearTimeout(this.employeeSearchTimeOut);
            this.employeeSearchTimeOut = setTimeout(() => { this.getAlreadyAssignedEmployeesForDeviceMainPage() }, 1000);
        });
    }

    onDeviceProjectSearch(event) {
        this.setState({ searchDeviceProjectText: event.target.value }, () => {
            clearTimeout(this.projectSearchTimeOut);
            this.projectSearchTimeOut = setTimeout(() => { this.getAlreadyAssignedProjectsForDeviceMainPage() }, 1000);
        });
    }

    onUnAssignDeviceProjectSearch(event) {
        this.searchUnAssignDeviceProText = event.target.value?.toLocaleLowerCase();
        this.unAssignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
        clearTimeout(this.unAssignProSearchTimeOut);
        this.unAssignProSearchTimeOut = setTimeout(() => { this.searchAndFilterUnAssignedPros() }, 1000);
    }

    onAssignDeviceProjectSearch(event) {
        this.searchAssignDeviceProText = event.target.value?.toLocaleLowerCase();
        this.assignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
        clearTimeout(this.assignProSearchTimeOut);
        this.assignProSearchTimeOut = setTimeout(() => { this.searchAndFilterAssignedPros() }, 1000);
    }

    onUnAssignDeviceEmployeeSearch(event) {
        this.searchUnAssignDeviceEmpText = event.target.value?.toLocaleLowerCase();
        this.unAssignedProsCurrentTake = Constants.DEFAULT_TAKE;
        clearTimeout(this.unAssignEmpSearchTimeOut);
        this.unAssignEmpSearchTimeOut = setTimeout(() => { this.searchAndFilterUnAssignedEmps() }, 1000);
    }

    onAssignDeviceEmployeeSearch(event) {
        this.searchAssignDeviceEmpText = event.target.value?.toLocaleLowerCase();
        this.assignedProsCurrentTake = Constants.DEFAULT_TAKE;
        clearTimeout(this.assignEmpSearchTimeOut);
        this.assignEmpSearchTimeOut = setTimeout(() => { this.searchAndFilterAssignedEmps() }, 1000);
    }

    onPageChange = (e, { activePage }) => {
        const { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({ pagination }, () => {
            this.getAllDevices();
        });
    }

    renderOptions() {
        return this.state.status.map((data, i) => {
            return (
                <MenuItem
                    label="Status"
                    value={data.value}
                    key={i} option={data.option}>{data.option}
                </MenuItem>
            );
        });
    }

    setSelectedDevice({ deviceId, apiRequest = true, dontChangeSelectedDevice = false }) {
        if (!dontChangeSelectedDevice) {
            this.currentlySelectedDevice = deviceId === -1 ? null : this.allDevices?.find(a => a.deviceID === deviceId) ?? null;
        }

        if (apiRequest) {
            this.getAlreadyAssignedEmployeesForDeviceMainPage();
            this.getAlreadyAssignedProjectsForDeviceMainPage();
        }
    }

    getSelectedDevice() {
        return this.currentlySelectedDevice ?? { deviceID: null };
    }

    editSelectedDeviceAssignEmployeesAndProjects({ modalOpen, deviceId }) {
        if (modalOpen) {
            this.setSelectedDevice({ deviceId, apiRequest: false });
            this.editingDeviceId = deviceId;
            this.setState({
                isEditAssignEmployeeAndProject: true,
            }, () => {
                this.getAssignedEmployeesForDeviceModal();
                this.getAssignedProjectsForDeviceModal();
                this.getDeviceDetails();
            });
        } else {
            this.resetAll({ dontChangeSelectedDevice: true });
        }
    }

    resetAll({ dontChangeSelectedDevice = false } = {}) {
        this.currentlySelectedDeviceDetails = null;
        this.currentCopyEmpDeviceCurrentTake = Constants.DEFAULT_TAKE;
        this.currentCopyProDeviceCurrentTake = Constants.DEFAULT_TAKE;
        this.unAssignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
        this.assignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
        this.unAssignedProsCurrentTake = Constants.DEFAULT_TAKE;
        this.assignedProsCurrentTake = Constants.DEFAULT_TAKE;
        this.fetchedAssignedEmps = false;
        this.tempAssignedEmpIds = null;
        this.fetchedAssignedPros = false;
        this.tempAssignedProIds = null;
        this.editingDeviceId = null;
        this.selectedCopyDevice = null;
        this.searchUnAssignDeviceEmpText = "";
        this.searchAssignDeviceEmpText = "";
        this.searchUnAssignDeviceProText = "";
        this.searchAssignDeviceProText = "";
        this.searchCopyDeviceEmpText = "";
        this.searchCopyDeviceProText = "";

        this.originalAssignedEmps.clear();
        this.orginalAssignedPros.clear();

        this.empUnAssignTrackMap.clear();
        this.empAssignTrackMap.clear();
        this.proUnAssignTrackMap.clear();
        this.proAssignTrackMap.clear();

        this.assignEmpSearchTimeOut = null;
        this.unAssignEmpSearchTimeOut = null;
        this.assignProSearchTimeOut = null;
        this.unAssignProSearchTimeOut = null;

        this.allUnAssignedEmpsWithoutSlicing.clear();
        this.allAssignedEmpsWithoutSlicing.clear();
        this.allUnAssignedProsWithoutSlicing.clear();
        this.allAssignedProsWithoutSlicing.clear();
        this.allCopyDevicesForEmpWithoutSlicing.clear();
        this.allCopyDevicesForProWithoutSlicing.clear();

        this.setState({
            isEditAssignEmployeeAndProject: false,

            // EMPLOYEE
            assignedEmpsForDeviceModal: [],
            unAssignedEmpsForDeviceModal: [],
            selectAllUnAssignedEmps: false,
            selectAllAssignedEmps: false,
            selectedUnAssignedEmpsMap: new Map(),
            selectedAssignedEmpsMap: new Map(),

            // PROJECT
            assignedProsForDeviceModal: [],
            unAssignedProsForDeviceModal: [],
            selectAllUnAssignedPros: false,
            selectAllAssignedPros: false,
            selectedUnAssignedProsMap: new Map(),
            selectedAssignedProsMap: new Map(),

            // COPY
            isCopyDevice: false,
            copyDeviceListForEmployee: [],
            copyDeviceListForProject: [],
            isDisableReplaceOrAppendBtn: false,
            selectedCopyDevicesForEmp: new Map(),
            selectedCopyDevicesForPro: new Map(),
            selectAllCopyDevicesForEmp: false,
            selectAllCopyDevicesForPro: false,

            saveBtnDisabled: false,
            isSetButtonDisabled: false,
            isEditDevice: false,
            selectedDeviceDetails: [],
        }, () => {
            this.getAllDevices({ dontChangeSelectedDevice });
        });
    }

    saveAssignOrUnassignEmployeeAndProject() {
        const { selectedDeviceDetails, employeeEmails } = this.state;
        const deviceId = this.getSelectedDevice().deviceID;
        if (!deviceId) return;

        if (!selectedDeviceDetails.empID || !employeeEmails.find(a => a.value === selectedDeviceDetails.empID)) {
            MessageBox(Constants.PLEASE_SELECT_EMPLOYEE_EMAIL, Constants.ERROR);
            return;
        }

        const originalEmpIds = [...this.originalAssignedEmps.keys()];
        const originalProIds = [...this.orginalAssignedPros.keys()];
        const assignedEmpIds = [...this.empAssignTrackMap.keys()];
        const assignedProIds = [...this.proAssignTrackMap.keys()];
        const employeeChanged = originalEmpIds.length !== assignedEmpIds.length || !originalEmpIds.every(a => assignedEmpIds.includes(a));
        const projectChanged = originalProIds.length !== assignedProIds.length || !originalProIds.every(a => assignedProIds.includes(a));

        if (employeeChanged || projectChanged || this.currentlySelectedDeviceDetails?.empID !== selectedDeviceDetails.empID) {
            const employees = [];
            const projects = [];

            const deletedAssignedEmps = originalEmpIds.filter(a => !this.empAssignTrackMap.has(a));
            const newlyAssignedEmps = assignedEmpIds.filter(a => !this.originalAssignedEmps.has(a));
            const deletedAssignedPros = originalProIds.filter(a => !this.proAssignTrackMap.has(a));
            const newlyAssignedPros = assignedProIds.filter(a => !this.orginalAssignedPros.has(a));

            deletedAssignedEmps.forEach(a => employees.push({ employeeId: a, status: "deleted" }));
            newlyAssignedEmps.forEach(a => employees.push({ employeeId: a, status: "new" }));

            deletedAssignedPros.forEach(a => projects.push({ projectId: a, status: "deleted" }));
            newlyAssignedPros.forEach(a => projects.push({ projectId: a, status: "new" }));

            this.setState({ saveBtnDisabled: true }, () => {
                const requestData = {
                    DeviceID: deviceId,
                    empID: selectedDeviceDetails.empID,
                    ModifiedById: this.props.user.userId,
                    Employees: employees,
                    Projects: projects,
                    employeeChanged: employeeChanged,
                    projectChanged: projectChanged,
                };

                const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.UT_DEVCE_UN_EMPLE_A_PJT_M}?deviceId=${deviceId}`;
                Api.Post(url, requestData, this).then((responseData) => {
                    if (responseData) {
                        if (responseData.success) {
                            this.resetAll({ dontChangeSelectedDevice: true });
                        } else {
                            this.setState({ saveBtnDisabled: false });
                        }
                        MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                    }
                });
            });
        } else {
            MessageBox(Constants.SAVED_SUCCESSFULLY, Constants.SUCCESS);
            this.resetAll();
        }
    }

    assignOrUnassignProsToDevices({ isForAssign }) {
        const { selectedUnAssignedProsMap, selectedAssignedProsMap } = this.state;
        if (selectedUnAssignedProsMap.size === 0 && selectedAssignedProsMap.size === 0) return;

        const unAssignSearchText = this.searchUnAssignDeviceProText ?? "";
        const assignSearchText = this.searchAssignDeviceProText ?? "";

        // UnAssign To Assign
        if (isForAssign) {
            const goingToAssignPros = this.allProjects
                ?.filter(a => selectedUnAssignedProsMap.has(a.projectID));

            if (goingToAssignPros?.length > 0) {
                this.unAssignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
                this.assignedEmpsCurrentTake = Constants.DEFAULT_TAKE;

                goingToAssignPros.forEach(a => {
                    selectedUnAssignedProsMap.delete(a.projectID);
                    this.proUnAssignTrackMap.delete(a.projectID);
                    this.proAssignTrackMap.set(a.projectID, true);
                    this.allUnAssignedProsWithoutSlicing.delete(a.projectID);
                });

                const newUnAssignedProsForDeviceModal = this.allProjects
                    ?.filter(a => this.proUnAssignTrackMap.has(a.projectID))
                    ?.filter(a => unAssignSearchText.length === 0 ? true : `${a.projectNumber} - ${a.projectName}`?.toLowerCase()?.includes(unAssignSearchText));

                const newAssignedProsForDeviceModal = this.allProjects
                    ?.filter(a => this.proAssignTrackMap.has(a.projectID))
                    ?.filter(a => assignSearchText.length === 0 ? true : `${a.projectNumber} - ${a.projectName}`?.toLowerCase()?.includes(assignSearchText));

                const assignedProIds = newAssignedProsForDeviceModal.map(a => a.projectID);
                assignedProIds.forEach(a => this.allAssignedProsWithoutSlicing.set(a, true));
                this.resetScrollPosition(Constants.DEVICE_PROJECT_SECTION_SCROLL);
                this.setState({
                    selectedAssignedProsMap,
                    selectedUnAssignedProsMap,
                    unAssignedProsForDeviceModal: newUnAssignedProsForDeviceModal?.slice(0, this.unAssignedEmpsCurrentTake),
                    assignedProsForDeviceModal: newAssignedProsForDeviceModal?.slice(0, this.assignedEmpsCurrentTake),
                    selectAllUnAssignedPros: false,
                    selectAllAssignedPros: assignedProIds.length > 0 && assignedProIds.every(a => selectedAssignedProsMap.has(a))
                });
            }
        } else {
            // Assign To UnAssign
            const goingToUnAssignPros = this.allProjects
                ?.filter(a => selectedAssignedProsMap.has(a.projectID));

            if (goingToUnAssignPros?.length > 0) {
                this.unAssignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
                this.assignedEmpsCurrentTake = Constants.DEFAULT_TAKE;

                goingToUnAssignPros.forEach(a => {
                    selectedAssignedProsMap.delete(a.projectID);
                    this.proAssignTrackMap.delete(a.projectID);
                    this.proUnAssignTrackMap.set(a.projectID, true);
                    this.allAssignedProsWithoutSlicing.delete(a.projectID);
                });

                const newUnAssignedProsForDeviceModal = this.allProjects
                    ?.filter(a => this.proUnAssignTrackMap.has(a.projectID))
                    ?.filter(a => unAssignSearchText.length === 0 ? true : `${a.projectNumber} - ${a.projectName}`?.toLowerCase()?.includes(unAssignSearchText));

                const newAssignedProsForDeviceModal = this.allProjects
                    ?.filter(a => this.proAssignTrackMap.has(a.projectID))
                    ?.filter(a => assignSearchText.length === 0 ? true : `${a.projectNumber} - ${a.projectName}`?.toLowerCase()?.includes(assignSearchText));

                const unAssignedProIds = newUnAssignedProsForDeviceModal.map(a => a.projectID);
                unAssignedProIds.forEach(a => this.allUnAssignedProsWithoutSlicing.set(a, true));
                this.resetScrollPosition(Constants.DEVICE_PROJECT_SECTION_SCROLL);
                this.setState({
                    selectedAssignedProsMap,
                    selectedUnAssignedProsMap,
                    assignedProsForDeviceModal: newAssignedProsForDeviceModal?.slice(0, this.assignedEmpsCurrentTake),
                    unAssignedProsForDeviceModal: newUnAssignedProsForDeviceModal?.slice(0, this.unAssignedEmpsCurrentTake),
                    selectAllUnAssignedPros: unAssignedProIds.length > 0 && unAssignedProIds.every(a => selectedUnAssignedProsMap.has(a)),
                    selectAllAssignedPros: false
                });
            }
        }
    }

    selectOrUnSelectAllUnAssignedPros(e, { value }) {
        const { selectedUnAssignedProsMap } = this.state;
        let checked = value?.checked ?? false;

        if (this.allUnAssignedProsWithoutSlicing?.size === 0) checked = false;
        if (checked) {
            this.allUnAssignedProsWithoutSlicing.forEach((v, k) => selectedUnAssignedProsMap.set(k, v));
        } else {
            this.allUnAssignedProsWithoutSlicing.forEach((_, k) => selectedUnAssignedProsMap.delete(k));
        }

        this.setState({ selectAllUnAssignedPros: checked, selectedUnAssignedProsMap });
    }

    selectOrUnSelectAllAssignedPros(e, { value }) {
        const { selectedAssignedProsMap } = this.state;
        let checked = value?.checked ?? false;

        if (this.allAssignedProsWithoutSlicing?.size === 0) checked = false;
        if (checked) {
            this.allAssignedProsWithoutSlicing.forEach((v, k) => selectedAssignedProsMap.set(k, v))
        } else {
            this.allAssignedProsWithoutSlicing.forEach((_, k) => selectedAssignedProsMap.delete(k));
        }

        this.setState({ selectAllAssignedPros: checked, selectedAssignedProsMap });
    }

    addOrRemoveSelectedUnAssignedPro({ proId }) {
        const { selectedUnAssignedProsMap, unAssignedProsForDeviceModal } = this.state;
        const proIds = unAssignedProsForDeviceModal.map(a => a.projectID);
        if (selectedUnAssignedProsMap.has(proId)) {
            selectedUnAssignedProsMap.delete(proId);
        } else {
            selectedUnAssignedProsMap.set(proId, true);
        }

        this.setState({ selectedUnAssignedProsMap, selectAllUnAssignedPros: proIds.every(a => selectedUnAssignedProsMap.has(a)) });
    }

    addOrRemoveSelectedAssignedPro({ proId }) {
        const { selectedAssignedProsMap, assignedProsForDeviceModal } = this.state;
        const proIds = assignedProsForDeviceModal.map(a => a.projectID);
        if (selectedAssignedProsMap.has(proId)) {
            selectedAssignedProsMap.delete(proId);
        } else {
            selectedAssignedProsMap.set(proId, true);
        }

        this.setState({ selectedAssignedProsMap, selectAllAssignedPros: proIds.every(a => selectedAssignedProsMap.has(a)) });
    }

    // EMPLOYEE
    assignOrUnassignEmpsToDevices({ isForAssign }) {
        const { selectedUnAssignedEmpsMap, selectedAssignedEmpsMap } = this.state;
        if (selectedUnAssignedEmpsMap.size === 0 && selectedAssignedEmpsMap.size === 0) return;

        const unAssignSearchtext = this.searchUnAssignDeviceEmpText?.split(" ");
        const assignSearchtext = this.searchAssignDeviceEmpText?.split(" ");

        // UnAssign To Assign
        if (isForAssign) {
            const goingToAssignEmps = this.allEmployees
                ?.filter(a => selectedUnAssignedEmpsMap.has(a.empID));

            if (goingToAssignEmps?.length > 0) {
                this.unAssignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
                this.assignedEmpsCurrentTake = Constants.DEFAULT_TAKE;

                goingToAssignEmps.forEach(a => {
                    selectedUnAssignedEmpsMap.delete(a.empID);
                    this.empUnAssignTrackMap.delete(a.empID);
                    this.empAssignTrackMap.set(a.empID, true);
                    this.allUnAssignedEmpsWithoutSlicing.delete(a.empID);
                });

                const newUnAssignedEmpsForDeviceModal = this.allEmployees
                    ?.filter(a => this.empUnAssignTrackMap.has(a.empID))
                    ?.filter(a => unAssignSearchtext.every(b => `${a.employeeNumber} - ${a.fullName}${a.division}${a.projectNumber}`?.toLowerCase()?.includes(b)));

                const newAssignedEmpsForDeviceModal = this.allEmployees
                    ?.filter(a => this.empAssignTrackMap.has(a.empID))
                    ?.filter(a => assignSearchtext.every(b => `${a.employeeNumber} - ${a.fullName}${a.division}${a.projectNumber}`?.toLowerCase()?.includes(b)));

                const assignedEmpIds = newAssignedEmpsForDeviceModal.map(a => a.empID);
                assignedEmpIds.forEach(a => this.allAssignedEmpsWithoutSlicing.set(a, true));
                this.resetScrollPosition(Constants.DEVICE_EMPLOYEE_SECTION_SCROLL);
                this.setState({
                    selectedAssignedEmpsMap,
                    selectedUnAssignedEmpsMap,
                    unAssignedEmpsForDeviceModal: newUnAssignedEmpsForDeviceModal?.slice(0, this.unAssignedEmpsCurrentTake),
                    assignedEmpsForDeviceModal: newAssignedEmpsForDeviceModal?.slice(0, this.assignedEmpsCurrentTake),
                    selectAllUnAssignedEmps: false,
                    selectAllAssignedEmps: assignedEmpIds.length > 0 && assignedEmpIds.every(a => selectedAssignedEmpsMap.has(a))
                });
            }
        } else {
            // Assign To UnAssign
            const goingToUnAssignEmps = this.allEmployees
                ?.filter(a => selectedAssignedEmpsMap.has(a.empID));

            if (goingToUnAssignEmps?.length > 0) {
                this.unAssignedEmpsCurrentTake = Constants.DEFAULT_TAKE;
                this.assignedEmpsCurrentTake = Constants.DEFAULT_TAKE;

                goingToUnAssignEmps.forEach(a => {
                    selectedAssignedEmpsMap.delete(a.empID);
                    this.empAssignTrackMap.delete(a.empID);
                    this.empUnAssignTrackMap.set(a.empID, true);
                    this.allAssignedEmpsWithoutSlicing.delete(a.empID);
                });

                const newUnAssignedEmpsForDeviceModal = this.allEmployees
                    ?.filter(a => this.empUnAssignTrackMap.has(a.empID))
                    ?.filter(a => unAssignSearchtext.every(b => `${a.employeeNumber} - ${a.fullName}${a.division}${a.projectNumber}`?.toLowerCase()?.includes(b)));

                const newAssignedEmpsForDeviceModal = this.allEmployees
                    ?.filter(a => this.empAssignTrackMap.has(a.empID))
                    ?.filter(a => assignSearchtext.every(b => `${a.employeeNumber} - ${a.fullName}${a.division}${a.projectNumber}`?.toLowerCase()?.includes(b)));

                const unAssignedEmpIds = newUnAssignedEmpsForDeviceModal.map(a => a.empID);
                unAssignedEmpIds.forEach(a => this.allUnAssignedEmpsWithoutSlicing.set(a, true));
                this.resetScrollPosition(Constants.DEVICE_EMPLOYEE_SECTION_SCROLL);
                this.setState({
                    selectedAssignedEmpsMap,
                    selectedUnAssignedEmpsMap,
                    assignedEmpsForDeviceModal: newAssignedEmpsForDeviceModal?.slice(0, this.assignedEmpsCurrentTake),
                    unAssignedEmpsForDeviceModal: newUnAssignedEmpsForDeviceModal?.slice(0, this.unAssignedEmpsCurrentTake),
                    selectAllUnAssignedEmps: unAssignedEmpIds.length > 0 && unAssignedEmpIds.every(a => selectedUnAssignedEmpsMap.has(a)),
                    selectAllAssignedEmps: false
                });
            }
        }
    }

    selectOrUnSelectAllUnAssignedEmps(e, { value }) {
        const { selectedUnAssignedEmpsMap } = this.state;
        let checked = value?.checked ?? false;

        if (this.allUnAssignedEmpsWithoutSlicing?.size === 0) checked = false;
        if (checked) {
            this.allUnAssignedEmpsWithoutSlicing.forEach((v, k) => selectedUnAssignedEmpsMap.set(k, v))
        } else {
            this.allUnAssignedEmpsWithoutSlicing.forEach((_, k) => selectedUnAssignedEmpsMap.delete(k));
        }

        this.setState({ selectAllUnAssignedEmps: checked, selectedUnAssignedEmpsMap });
    }

    selectOrUnSelectAllAssignedEmps(e, { value }) {
        const { selectedAssignedEmpsMap } = this.state;
        let checked = value?.checked ?? false;

        if (this.allAssignedEmpsWithoutSlicing?.size === 0) checked = false;
        if (checked) {
            this.allAssignedEmpsWithoutSlicing.forEach((v, k) => selectedAssignedEmpsMap.set(k, v))
        } else {
            this.allAssignedEmpsWithoutSlicing.forEach((_, k) => selectedAssignedEmpsMap.delete(k));
        }

        this.setState({ selectAllAssignedEmps: checked, selectedAssignedEmpsMap });
    }

    addOrRemoveSelectedUnAssignedEmp({ empID }) {
        const { selectedUnAssignedEmpsMap, unAssignedEmpsForDeviceModal } = this.state;
        const empIds = unAssignedEmpsForDeviceModal.map(a => a.empID);
        if (selectedUnAssignedEmpsMap.has(empID)) {
            selectedUnAssignedEmpsMap.delete(empID);
        } else {
            selectedUnAssignedEmpsMap.set(empID, true);
        }

        this.setState({ selectedUnAssignedEmpsMap, selectAllUnAssignedEmps: empIds.every(a => selectedUnAssignedEmpsMap.has(a)) });
    }

    addOrRemoveSelectedAssignedEmp({ empID }) {
        const { selectedAssignedEmpsMap, assignedEmpsForDeviceModal } = this.state;
        const empIds = assignedEmpsForDeviceModal.map(a => a.empID);
        if (selectedAssignedEmpsMap.has(empID)) {
            selectedAssignedEmpsMap.delete(empID);
        } else {
            selectedAssignedEmpsMap.set(empID, true);
        }

        this.setState({ selectedAssignedEmpsMap, selectAllAssignedEmps: empIds.every(a => selectedAssignedEmpsMap.has(a)) });
    }

    onClickEditDevice({ deviceId, modalOpen = false }) {
        if (modalOpen) {
            this.editingDeviceId = deviceId;
            this.setState({ isEditDevice: true }, () => {
                this.getDeviceDetails();
            });
        } else {
            this.resetAll({ dontChangeSelectedDevice: true });
        }
    }

    getDeviceDetails() {
        const deviceId = this.editingDeviceId;
        if (!deviceId) return;

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_DEVCE_DTS_M}?deviceId=${deviceId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    const selectedDeviceDetails = responseData.data;
                    selectedDeviceDetails.status = responseData.data.status.toLowerCase();
                    this.currentlySelectedDeviceDetails = this.clone(selectedDeviceDetails);
                    this.setState({ selectedDeviceDetails });
                } else {
                    this.currentlySelectedDeviceDetails = null;
                    this.setState({ selectedDeviceDetails: [] });
                }
            }
        });
    }

    handleStatusChange(e, { value }) {
        const { selectedDeviceDetails } = this.state;
        selectedDeviceDetails.status = value;
        this.setState({ selectedDeviceDetails });
    }

    handleEmployeeChange(e, { value }) {
        const { selectedDeviceDetails } = this.state;
        selectedDeviceDetails.empID = value;
        this.setState({ selectedDeviceDetails });
    }

    handleAttestationChange(e, { value }) {
        const { selectedDeviceDetails } = this.state;
        selectedDeviceDetails.allowAttestation = value;
        this.setState({ selectedDeviceDetails });
    }

    saveEmployeeDetails() {
        const { selectedDeviceDetails, employeeEmails } = this.state;

        if (!selectedDeviceDetails.empID || !employeeEmails.find(a => a.value === selectedDeviceDetails.empID) || !selectedDeviceDetails.status) {
            MessageBox(Constants.PLEASE_SELECT_EMPLOYEE_EMAIL, Constants.ERROR);
            return;
        }

        if (isTwoObjectSame(selectedDeviceDetails, this.currentlySelectedDeviceDetails)) {
            MessageBox(Constants.UPDATED_SUCCESSFULLY, Constants.SUCCESS);
            this.resetAll();
        } else {
            selectedDeviceDetails.modifiedById = this.props.user.userId;
            this.setState({ isSetButtonDisabled: true }, () => {
                const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.UPDT_DEVCE_DTS}`;
                Api.Post(url, selectedDeviceDetails, this).then((responseData) => {
                    if (responseData.success) {
                        MessageBox(Constants.UPDATED_SUCCESSFULLY, Constants.SUCCESS);
                        this.resetAll();
                    } else {
                        this.setState({ isEditDevice: false, isSetButtonDisabled: false });
                    }
                });
            });
        }
    }

    // COPY
    onClickCopyDevice(device) {
        if (device.deviceId) {
            this.editingDeviceId = device.deviceId;
            this.selectedCopyDevice = this.allDevices?.find(a => a.deviceID === device.deviceId);
            this.setState({ isCopyDevice: true }, () => {
                this.getCopyDeviceListEmployeeAndProject();
                this.getDeviceDetails();
            });
        } else {
            this.resetAll({ dontChangeSelectedDevice: true });
        }
    }

    searchAndFilterCopyDevicesForEmp() {
        const devices = this.allCopyDevices
            ?.filter(a => a?.deviceEmpID?.toLowerCase()?.includes(this.searchCopyDeviceEmpText));

        const deviceIds = devices.map(a => a.deviceID);
        this.allCopyDevicesForEmpWithoutSlicing.clear();
        deviceIds.forEach(a => {
            this.allCopyDevicesForEmpWithoutSlicing.set(a, true);
        });

        const selectAllCopyDevicesForEmp = deviceIds.length > 0 && deviceIds.every(a => this.state.selectedCopyDevicesForEmp.has(a));
        this.setState({ copyDeviceListForEmployee: devices.slice(0, this.currentCopyEmpDeviceCurrentTake), selectAllCopyDevicesForEmp });
    }

    searchAndFilterCopyDevicesForPro() {
        const devices = this.allCopyDevices
            ?.filter(a => a?.deviceEmpID?.toLowerCase()?.includes(this.searchCopyDeviceProText));

        const deviceIds = devices.map(a => a.deviceID);
        this.allCopyDevicesForProWithoutSlicing.clear();
        deviceIds.forEach(a => {
            this.allCopyDevicesForProWithoutSlicing.set(a, true);
        });

        const selectAllCopyDevicesForPro = deviceIds.length > 0 && deviceIds.every(a => this.state.selectedCopyDevicesForPro.has(a));
        this.setState({ copyDeviceListForProject: devices?.slice(0, this.currentCopyProDeviceCurrentTake), selectAllCopyDevicesForPro });
    }

    getCopyDeviceListEmployeeAndProject() {
        const searchArray = [];

        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        });

        const requestData = {
            SearchText: searchArray
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_CPYDVS_DT}?deviceId=${this.editingDeviceId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    this.allCopyDevices = responseData?.data ?? [];
                    const devices = this.allCopyDevices.slice(0, this.currentCopyEmpDeviceCurrentTake);
                    this.allCopyDevices.forEach(a => {
                        this.allCopyDevicesForEmpWithoutSlicing.set(a.deviceID, true);
                        this.allCopyDevicesForProWithoutSlicing.set(a.deviceID, true);
                    });
                    this.setState({ copyDeviceListForEmployee: devices, copyDeviceListForProject: devices });
                } else {
                    this.allCopyDevices = null;
                    this.setState({ copyDeviceListForEmployee: [], copyDeviceListForProject: [] });
                }
            }
        });
    }

    selectOrUnSelectAllCopyDevicesForEmp(e, { value }) {
        const { selectedCopyDevicesForEmp } = this.state;
        let checked = value?.checked ?? false;

        if (this.allCopyDevicesForEmpWithoutSlicing.size === 0) checked = false;
        if (checked) {
            this.allCopyDevicesForEmpWithoutSlicing.forEach((v, k) => selectedCopyDevicesForEmp.set(k, v));
        } else {
            this.allCopyDevicesForEmpWithoutSlicing.forEach((_, k) => selectedCopyDevicesForEmp.delete(k));
        }

        this.setState({ selectedCopyDevicesForEmp, selectAllCopyDevicesForEmp: checked });
    }

    selectOrUnSelectAllCopyDevicesForPro(e, { value }) {
        const { selectedCopyDevicesForPro } = this.state;
        let checked = value?.checked ?? false;

        if (this.allCopyDevicesForProWithoutSlicing.size === 0) checked = false;
        if (checked) {
            this.allCopyDevicesForProWithoutSlicing.forEach((v, k) => selectedCopyDevicesForPro.set(k, v));
        } else {
            this.allCopyDevicesForProWithoutSlicing.forEach((_, k) => selectedCopyDevicesForPro.delete(k));
        }

        this.setState({ selectedCopyDevicesForPro, selectAllCopyDevicesForPro: checked });
    }

    addOrRemoveCopyDeviceForEmployee(deviceId) {
        const { selectedCopyDevicesForEmp, copyDeviceListForEmployee } = this.state;
        const deviceIds = copyDeviceListForEmployee.map(a => a.deviceID);

        if (selectedCopyDevicesForEmp.has(deviceId)) {
            selectedCopyDevicesForEmp.delete(deviceId);
        } else {
            selectedCopyDevicesForEmp.set(deviceId, true);
        }

        this.setState({ selectedCopyDevicesForEmp, selectAllCopyDevicesForEmp: deviceIds.every(a => selectedCopyDevicesForEmp.has(a)) });
    }

    addOrRemoveCopyDeviceForProject(deviceId) {
        const { selectedCopyDevicesForPro, copyDeviceListForProject } = this.state;
        const deviceIds = copyDeviceListForProject.map(a => a.deviceID);

        if (selectedCopyDevicesForPro.has(deviceId)) {
            selectedCopyDevicesForPro.delete(deviceId);
        } else {
            selectedCopyDevicesForPro.set(deviceId, true);
        }

        this.setState({ selectedCopyDevicesForPro, selectAllCopyDevicesForPro: deviceIds.every(a => selectedCopyDevicesForPro.has(a)) });
    }

    onClickReplaceOrAppend(isReplace = false, isAppend = false) {
        const { selectedDeviceDetails, employeeEmails, selectedCopyDevicesForEmp, selectedCopyDevicesForPro } = this.state;

        if (!selectedDeviceDetails.empID || !employeeEmails.find(a => a.value === selectedDeviceDetails.empID)) {
            MessageBox(Constants.PLEASE_SELECT_EMPLOYEE_EMAIL, Constants.ERROR);
            return;
        }

        const deviceIdsForEmp = [...selectedCopyDevicesForEmp.keys()];
        const deviceIdsForPro = [...selectedCopyDevicesForPro.keys()];

        if (deviceIdsForEmp.length > 0 || deviceIdsForPro.length > 0) {
            this.setState({ isDisableReplaceOrAppendBtn: true }, () => {
                const requestData = {
                    ModifiedById: this.props.user.userId,
                    EmpId: selectedDeviceDetails.empID,
                    DeviceID: this.editingDeviceId,
                    EmployeeDeviceIds: deviceIdsForEmp,
                    ProjectDeviceIds: deviceIdsForPro,
                    IsReplace: isReplace,
                    IsAppend: isAppend
                };

                const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.SV_CPY_EMP_PRJ_TDVC}?deviceId=${this.editingDeviceId}`;
                Api.Post(url, requestData, this).then((responseData) => {
                    if (responseData) {
                        this.resetAll();
                        MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                    } else {
                        this.setState({ isDisableReplaceOrAppendBtn: false });
                    }
                });
            });
        } else {
            this.resetAll();
            MessageBox(Constants.SAVED_SUCCESSFULLY, Constants.SUCCESS);
        }
    }

    onSearchCopyDevicesForEmp(event) {
        this.searchCopyDeviceEmpText = event?.target?.value?.toLowerCase();
        this.currentCopyEmpDeviceCurrentTake = Constants.DEFAULT_TAKE;
        clearTimeout(this.copyDeviceForEmpTimeOut);
        this.copyDeviceForEmpTimeOut = setTimeout(() => this.searchAndFilterCopyDevicesForEmp(), 1000);
    }

    onSearchCopyDevicesForPro(event) {
        this.searchCopyDeviceProText = event?.target?.value?.toLowerCase();
        this.currentCopyProDeviceCurrentTake = Constants.DEFAULT_TAKE;
        clearTimeout(this.copyDeviceForProTimeOut);
        this.copyDeviceForProTimeOut = setTimeout(() => this.searchAndFilterCopyDevicesForPro(), 1000);
    }
    // COPY

    searchDeviceAttestationOptions() {
        const { selectedDeviceAttestationOptions } = this.state;
        this.setState({
            searchAttestationText: selectedDeviceAttestationOptions.length > 1 ? "" : selectedDeviceAttestationOptions[0]?.value ?? "",
            pagination: {
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE,
                activePage: 1,
                totalCount: 0
            }
        }, () => {
            setTimeout(() => { this.getAllDevices() }, 1000);
        });
    }

    searchDeviceSignatureOptions() {
        const { selectedDeviceSignatureOptions } = this.state;
        this.setState({
            searchSignatureText: selectedDeviceSignatureOptions.length > 1 ? "" : selectedDeviceSignatureOptions[0]?.value ?? "",
            pagination: {
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE,
                activePage: 1,
                totalCount: 0
            }
        }, () => {
            setTimeout(() => { this.getAllDevices() }, 1000);
        });
    }

    handleSignatureChange(e, { value }) {
        const { selectedDeviceDetails } = this.state;
        selectedDeviceDetails.allowTMVoucherSignature = value;
        this.setState({ selectedDeviceDetails });
    }

    handleSignatureOptionChange(selectedValue) {
        this.setState({ selectedDeviceSignatureOptions: selectedValue });
    }

    handleAttestationOptionChange(selectedVaue) {
        this.setState({ selectedDeviceAttestationOptions: selectedVaue });
    }

    resetScrollPosition(type) {
        const scrollMap = {
            [Constants.ASSIGN_EMP]: ["empAssignedScroll"],
            [Constants.UNASSIGN_EMP]: ["empUnAssignedScroll", "empUnAssignedDivScroll", "empUnAssignedProScroll"],
            [Constants.ASSIGN_PRO]: ["proAssignedScroll"],
            [Constants.UNASSIGN_PRO]: ["proUnAssignedScroll"],
            [Constants.DEVICE_EMPLOYEE_SECTION_SCROLL]: ["empAssignedScroll", "empUnAssignedScroll", "empUnAssignedDivScroll", "empUnAssignedProScroll"],
            [Constants.DEVICE_PROJECT_SECTION_SCROLL]: ["proUnAssignedScroll", "proAssignedScroll"]
        };

        const ids = scrollMap[type] || [];

        ids.forEach(id => {
            const element = document.getElementById(id);
            if (element) element.scrollTop = 0;
        });
    }

    randomString(length) {
        const alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        const chars = [];
        for (let i = 0; i < length; i++) {
            chars.push(alpha[Math.floor(Math.random() * alpha.length) % alpha.length]);
        }

        return chars.join("");
    }

    mockEmpResponse(count) {
        const allEmps = [];
        for (let i = 0; i < count; i++) {
            const emp = {
                empID: i + 1,
                fullName: "emp-" + (i + 1) + "-" + this.randomString(20),
                employeeNumber: "" + (i + 1) + "-" + this.randomString(6),
                division: "div-" + (i + 1),
                projectNumber: "project-" + (i + 1),
            };
            allEmps.push(emp);
        }
        return allEmps;
    }

    mockProResponse(count) {
        const allPros = [];
        for (let i = 0; i < count; i++) {
            const pro = {
                projectID: i + 1,
                projectName: "pro-" + (i + 1) + "-" + this.randomString(20),
                projectNumber: "" + (i + 1) + "-" + this.randomString(6),
            };
            allPros.push(pro);
        }
        return allPros;
    }

    render() {
        const {
            devicesList,
            selectedAsignedProject,
            employeeEmails,
            selectedStatus,
            searchDeviceText,
            searchDeviceEmployeeText,
            searchDeviceProjectText,
            status,
            isEditAssignEmployeeAndProject,
            pagination,
            selectedDeviceDetails,
            isEditDevice,
            deviceStatusOptions,
            isSetButtonDisabled,
            isCopyDevice,
            copyDeviceListForEmployee,
            copyDeviceListForProject,
            selectedDeviceAttestationOptions,
            deviceAttestationStatusOptions,
            deviceSignatureOptions,
            selectedDeviceSignatureOptions,
            isDisableReplaceOrAppendBtn,
            selectedCopyDevicesForEmp,
            selectedCopyDevicesForPro,
            selectAllCopyDevicesForEmp,
            selectAllCopyDevicesForPro,

            // EMPLOYEE
            assignedEmpsDevicesIntheMainPage,
            unAssignedEmpsForDeviceModal,
            assignedEmpsForDeviceModal,
            selectAllUnAssignedEmps,
            selectAllAssignedEmps,
            selectedUnAssignedEmpsMap,
            selectedAssignedEmpsMap,

            // PROJECT
            assignedProsDevicesIntheMainPage,
            unAssignedProsForDeviceModal,
            assignedProsForDeviceModal,
            selectAllUnAssignedPros,
            selectAllAssignedPros,
            selectedUnAssignedProsMap,
            selectedAssignedProsMap,

            saveBtnDisabled,
            searchUserNameText
        } = this.state;
        return (
            <Fragment>
                <DevicesComponent
                    {...{
                        device: {
                            devicesList,

                            selectedStatus,
                            status,
                            isEditAssignEmployeeAndProject,
                            selectedDevice: this.currentlySelectedDevice,
                            pagination,
                            selectedDeviceDetails,
                            isEditDevice,
                            deviceStatusOptions,
                            searchDeviceText,
                            searchDeviceEmployeeText,
                            searchDeviceProjectText,
                            selectedAsignedProject,
                            employeeEmails,
                            isSetButtonDisabled,
                            isCopyDevice,
                            selectedDeviceForCopy: this.selectedCopyDevice,
                            copyDeviceListForEmployee,
                            copyDeviceListForProject,
                            selectedDeviceAttestationOptions,
                            deviceAttestationStatusOptions,
                            deviceSignatureOptions,
                            selectedDeviceSignatureOptions,
                            isDisableReplaceOrAppendBtn,
                            selectedCopyDevicesForEmp,
                            selectedCopyDevicesForPro,
                            selectAllCopyDevicesForEmp,
                            selectAllCopyDevicesForPro,

                            // EMPLOYEE
                            assignedEmpsDevicesIntheMainPage,
                            unAssignedEmpsForDeviceModal,
                            assignedEmpsForDeviceModal,
                            selectAllUnAssignedEmps,
                            selectAllAssignedEmps,
                            selectedUnAssignedEmpsMap,
                            selectedAssignedEmpsMap,

                            // PROJECT
                            assignedProsDevicesIntheMainPage,
                            unAssignedProsForDeviceModal,
                            assignedProsForDeviceModal,
                            selectAllUnAssignedPros,
                            selectAllAssignedPros,
                            selectedUnAssignedProsMap,
                            selectedAssignedProsMap,

                            saveBtnDisabled,
                            searchUserNameText
                        }
                    }}
                    renderOptions={this.renderOptions.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    setSelectedDevice={this.setSelectedDevice.bind(this)}

                    onDeviceSearch={this.onDeviceSearch.bind(this)}
                    onDeviceProjectSearch={this.onDeviceProjectSearch.bind(this)}
                    onDeviceEmployeeSearch={this.onDeviceEmployeeSearch.bind(this)}
                    onUnAssignDeviceEmployeeSearch={this.onUnAssignDeviceEmployeeSearch.bind(this)}
                    onUnAssignDeviceProjectSearch={this.onUnAssignDeviceProjectSearch.bind(this)}

                    // EMPLOYEE
                    assignOrUnassignEmpsToDevices={this.assignOrUnassignEmpsToDevices.bind(this)}
                    selectOrUnSelectAllUnAssignedEmps={this.selectOrUnSelectAllUnAssignedEmps.bind(this)}
                    selectOrUnSelectAllAssignedEmps={this.selectOrUnSelectAllAssignedEmps.bind(this)}
                    onAssignDeviceEmployeeSearch={this.onAssignDeviceEmployeeSearch.bind(this)}
                    addOrRemoveSelectedUnAssignedEmp={this.addOrRemoveSelectedUnAssignedEmp.bind(this)}
                    addOrRemoveSelectedAssignedEmp={this.addOrRemoveSelectedAssignedEmp.bind(this)}

                    // PROJECT
                    assignOrUnassignProsToDevices={this.assignOrUnassignProsToDevices.bind(this)}
                    selectOrUnSelectAllUnAssignedPros={this.selectOrUnSelectAllUnAssignedPros.bind(this)}
                    selectOrUnSelectAllAssignedPros={this.selectOrUnSelectAllAssignedPros.bind(this)}
                    onAssignDeviceProjectSearch={this.onAssignDeviceProjectSearch.bind(this)}
                    addOrRemoveSelectedUnAssignedPro={this.addOrRemoveSelectedUnAssignedPro.bind(this)}
                    addOrRemoveSelectedAssignedPro={this.addOrRemoveSelectedAssignedPro.bind(this)}

                    editSelectedDeviceAssignEmployeesAndProjects={this.editSelectedDeviceAssignEmployeesAndProjects.bind(this)}
                    saveAssignOrUnassignEmployeeAndProject={this.saveAssignOrUnassignEmployeeAndProject.bind(this)}
                    onPageChange={this.onPageChange.bind(this)}
                    user={this.props.user}
                    onClickEditDevice={this.onClickEditDevice.bind(this)}
                    handleStatusChange={this.handleStatusChange.bind(this)}
                    handleEmployeeChange={this.handleEmployeeChange.bind(this)}
                    saveEmployeeDetails={this.saveEmployeeDetails.bind(this)}
                    handleAttestationChange={this.handleAttestationChange.bind(this)}
                    searchDeviceAttestationOptions={this.searchDeviceAttestationOptions.bind(this)}
                    searchDeviceSignatureOptions={this.searchDeviceSignatureOptions.bind(this)}
                    handleSignatureChange={this.handleSignatureChange.bind(this)}
                    handleSignatureOptionChange={this.handleSignatureOptionChange.bind(this)}
                    handleAttestationOptionChange={this.handleAttestationOptionChange.bind(this)}

                    // COPY
                    onClickCopyDevice={this.onClickCopyDevice.bind(this)}
                    addOrRemoveCopyDeviceForEmployee={this.addOrRemoveCopyDeviceForEmployee.bind(this)}
                    addOrRemoveCopyDeviceForProject={this.addOrRemoveCopyDeviceForProject.bind(this)}
                    selectOrUnSelectAllCopyDevicesForPro={this.selectOrUnSelectAllCopyDevicesForPro.bind(this)}
                    selectOrUnSelectAllCopyDevicesForEmp={this.selectOrUnSelectAllCopyDevicesForEmp.bind(this)}
                    onClickReplaceOrAppend={this.onClickReplaceOrAppend.bind(this)}
                    onSearchCopyDevicesForEmp={this.onSearchCopyDevicesForEmp.bind(this)}
                    onSearchCopyDevicesForPro={this.onSearchCopyDevicesForPro.bind(this)}
                    fetchNext={this.fetchNext.bind(this)}
                />
            </Fragment>
        )
    }
};

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Devices));

Devices.displayName = 'Devices';